export const messages = {
  en: {
    listRoomDecorationRecord: {
      title: 'Decoration Tracking Record',
      add: 'Add',
      back: 'Back',
      recordId: 'Record ID',
      room: 'Room',
      operator: 'Operator',
      createTime: 'Create Time',
      status: 'Status',
      originalImage: 'Original Image',
      isViolation: 'Is Violation',
      remark: 'Remark',
      operation: 'Operation',
      viewDetails: 'View Details',
      delete: 'Delete',
      fetchError: 'Failed to fetch decoration records'
    },
    roomDecorationRecord: {
      title: 'Decoration Tracking',
      room: 'Room',
      roomPlaceholder: 'Required, please fill in the room',
      status: 'Status',
      isViolation: 'Is Violation',
      isViolationPlaceholder: 'Please select whether it is a violation',
      yes: 'Yes',
      no: 'No',
      remark: 'Remark',
      remarkPlaceholder: 'Please fill in the remark',
      uploadImage: 'Upload Image',
      uploadVideo: 'Upload Video',
      isViolationRequired: 'Is violation is required',
      remarkRequired: 'Remark is required'
    },
    uploadImage: {
      imageSizeLimit: 'Image size cannot exceed 2MB',
      uploadFailed: 'Failed to upload image'
    },
    uploadVedio: {
      upload: 'Upload Video',
      sizeLimit: 'Video size cannot exceed 500MB',
      success: 'Video uploaded successfully',
      failed: 'Failed to upload video'
    },
    deleteRoomDecorationRecord: {
      title: 'Confirm Your Operation',
      confirm: 'Are you sure to delete the room decoration record?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      success: 'Deleted successfully',
      failed: 'Failed to delete'
    }
  },
  zh: {
    listRoomDecorationRecord: {
      title: '装修跟踪记录',
      add: '添加',
      back: '返回',
      recordId: '记录ID',
      room: '房屋',
      operator: '操作人员',
      createTime: '创建时间',
      status: '状态',
      originalImage: '原始图片',
      isViolation: '是否违规',
      remark: '备注',
      operation: '操作',
      viewDetails: '查看详情',
      delete: '删除',
      fetchError: '获取装修记录失败'
    },
    roomDecorationRecord: {
      title: '装修跟踪',
      room: '房屋',
      roomPlaceholder: '必填，请填写房屋',
      status: '状态',
      isViolation: '是否违规',
      isViolationPlaceholder: '请选择是否违规',
      yes: '是',
      no: '否',
      remark: '备注',
      remarkPlaceholder: '请填写备注',
      uploadImage: '上传图片',
      uploadVideo: '上传视频',
      isViolationRequired: '是否违规不能为空',
      remarkRequired: '备注不能为空'
    },
    uploadImage: {
      imageSizeLimit: '图片大小不能超过2MB',
      uploadFailed: '图片上传失败'
    },
    uploadVedio: {
      upload: '上传视频',
      sizeLimit: '视频大小不能超过500MB',
      success: '视频上传成功',
      failed: '视频上传失败'
    },
    deleteRoomDecorationRecord: {
      title: '请确认您的操作',
      confirm: '确定删除房屋装修记录？',
      cancel: '点错了',
      confirmDelete: '确认删除',
      success: '删除成功',
failed: '删除失败'
    }
  },
  'zh-TW': {
    listRoomDecorationRecord: {
      title: '装修跟踪记录',
      add: '添加',
      back: '返回',
      recordId: '记录ID',
      room: '房屋',
      operator: '操作人员',
      createTime: '创建时间',
      status: '状态',
      originalImage: '原始图片',
      isViolation: '是否违规',
      remark: '备注',
      operation: '操作',
      viewDetails: '查看详情',
      delete: '删除',
      fetchError: '获取装修记录失败'
    },
    roomDecorationRecord: {
      title: '装修跟踪',
      room: '房屋',
      roomPlaceholder: '必填，请填写房屋',
      status: '状态',
      isViolation: '是否违规',
      isViolationPlaceholder: '请选择是否违规',
      yes: '是',
      no: '否',
      remark: '备注',
      remarkPlaceholder: '请填写备注',
      uploadImage: '上传图片',
      uploadVideo: '上传视频',
      isViolationRequired: '是否违规不能为空',
      remarkRequired: '备注不能为空'
    },
    uploadImage: {
      imageSizeLimit: '图片大小不能超过2MB',
      uploadFailed: '图片上传失败'
    },
    uploadVedio: {
      upload: '上传视频',
      sizeLimit: '视频大小不能超过500MB',
      success: '视频上传成功',
      failed: '视频上传失败'
    },
    deleteRoomDecorationRecord: {
      title: '请确认您的操作',
      confirm: '确定删除房屋装修记录？',
      cancel: '点错了',
      confirmDelete: '确认删除',
      success: '删除成功',
      failed: '删除失败'
    }
  }
}